document.addEventListener('DOMContentLoaded', function () {
  // Product gallery thumbnail swap
  var mainImage = document.getElementById('MainProductImage');
  var thumbs = document.querySelectorAll('.product-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) {
        mainImage.src = thumb.getAttribute('data-full');
      }
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // Mobile nav toggle
  var toggle = document.querySelector('.header-mobile-toggle');
  var nav = document.querySelector('.site-header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.style.display === 'flex';
      nav.style.display = isOpen ? 'none' : 'flex';
      nav.style.flexDirection = 'column';
      nav.style.position = 'absolute';
      nav.style.top = '100%';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.background = 'var(--color-cream)';
      nav.style.padding = '20px';
      nav.style.gap = '18px';
    });
  }
});
